module.exports = __webpack_public_path__ + "de77a722/img/pwrd-by-sourcery-black.bba9ba41.svg";